import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchAllUserAgents,
  deleteAgent,
  upsertAgent,
  fetchAgent,
} from "./agentAPI";

export const getAgents = createAsyncThunk("agent/allUser", async (thunkAPI) => {
  try {
    const data = await fetchAllUserAgents();
    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || error.message);
  }
});

export const removeAgent = createAsyncThunk(
  "agent/removeAgent",
  async (uuid, thunkAPI) => {
    try {
      const data = await deleteAgent(uuid);
      return { uuid, data };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const insertOrUpdateAgent = createAsyncThunk(
  "agent/upsert",
  async (agentData, thunkAPI) => {
    try {
      const data = await upsertAgent(agentData);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getAgent = createAsyncThunk(
  "agent/getAgent",
  async (uuid, thunkAPI) => {
    try {
      const data = await fetchAgent(uuid);
      return data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  },
);

const agentSlice = createSlice({
  name: "agent",
  initialState: {
    agents: [],
    selectedAgent: null,
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAgents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAgents.fulfilled, (state, action) => {
        state.loading = false;
        state.agents = action.payload.data;
      })
      .addCase(getAgents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getAgent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAgent.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedAgent = action.payload;
      })
      .addCase(getAgent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(removeAgent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeAgent.fulfilled, (state, action) => {
        state.loading = false;
        state.agents = state.agents.filter(
          (a) => a.uuid !== action.payload.uuid,
        );
      })
      .addCase(removeAgent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(insertOrUpdateAgent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(insertOrUpdateAgent.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedAgent = action.payload.agent;
      })
      .addCase(insertOrUpdateAgent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default agentSlice.reducer;
